// Reports listing
export const GET_REPORTS_LIST = "GET_REPORTS_LIST";
export const GET_REPORTS_LIST_SUCCESS = "GET_REPORTS_LIST_SUCCESS";
export const GET_REPORTS_LIST_ERROR = "GET_REPORTS_LIST_ERROR";

// Report detail
export const GET_REPORT_DETAIL = "GET_REPORT_DETAIL";
export const GET_REPORT_DETAIL_SUCCESS = "GET_REPORT_DETAIL_SUCCESS";
export const GET_REPORT_DETAIL_ERROR = "GET_REPORT_DETAIL_ERROR";

// Update report status
export const UPDATE_REPORT_STATUS = "UPDATE_REPORT_STATUS";
export const UPDATE_REPORT_STATUS_SUCCESS = "UPDATE_REPORT_STATUS_SUCCESS";
export const UPDATE_REPORT_STATUS_ERROR = "UPDATE_REPORT_STATUS_ERROR";

// Set active tab
export const SET_REPORTS_ACTIVE_TAB = "SET_REPORTS_ACTIVE_TAB";

// Set search
export const SET_REPORTS_SEARCH = "SET_REPORTS_SEARCH";

// Set sort
export const SET_REPORTS_SORT_FIELD = "SET_REPORTS_SORT_FIELD";
export const SET_REPORTS_SORT_ORDER = "SET_REPORTS_SORT_ORDER";

// Set page
export const SET_REPORTS_PAGE = "SET_REPORTS_PAGE";

